var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "onlineDeclaration" },
    [
      _vm._m(0),
      _c("div", { staticClass: "tips" }, [
        _vm._v(
          " 在每年的5月初和11月初根据学院官网通知开放网上申报通道。在申报页面填写个人申报信息时注意填写要求 。申请提交后由学院审批，请关注审批结果。 "
        ),
      ]),
      _c("div", { staticClass: "cont" }, [
        _c("div", { staticClass: "cont-title" }, [_vm._v("学位申报报名流程")]),
        _c(
          "div",
          { staticClass: "form-box" },
          [
            _c("div", { staticClass: "form-title" }, [_vm._v("个人基本信息")]),
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm modify-ruleForm",
                attrs: { model: _vm.ruleForm, rules: _vm.rules },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "姓名", prop: "student_title" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "8" },
                              attrs: {
                                placeholder: "请输入姓名",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.student_title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "student_title", $$v)
                                },
                                expression: "ruleForm.student_title",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "民族", prop: "nat_id" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择民族",
                                  clearable: "",
                                  filterable: "",
                                },
                                on: { change: _vm.natChange },
                                model: {
                                  value: _vm.nation,
                                  callback: function ($$v) {
                                    _vm.nation = $$v
                                  },
                                  expression: "nation",
                                },
                              },
                              _vm._l(_vm.nationList, function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    value:
                                      item.id + "-" + item.mzdm + "-" + item.mz,
                                    label: item.mz,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "身份证", prop: "identity" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "8" },
                              attrs: {
                                placeholder: "请输入身份证",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.identity,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "identity", $$v)
                                },
                                expression: "ruleForm.identity",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "性别", prop: "sex" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                staticStyle: { width: "100%" },
                                on: { change: _vm.sexChange },
                                model: {
                                  value: _vm.sex,
                                  callback: function ($$v) {
                                    _vm.sex = $$v
                                  },
                                  expression: "sex",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "1-男" } }, [
                                  _vm._v("男"),
                                ]),
                                _c("el-radio", { attrs: { label: "2-女" } }, [
                                  _vm._v("女"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "政治面貌", prop: "pol_code" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择政治面貌",
                                  clearable: "",
                                  filterable: "",
                                },
                                on: { change: _vm.polChange },
                                model: {
                                  value: _vm.politicalOutlook,
                                  callback: function ($$v) {
                                    _vm.politicalOutlook = $$v
                                  },
                                  expression: "politicalOutlook",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: "13-群众", label: "群众" },
                                }),
                                _c("el-option", {
                                  attrs: { value: "01-党员", label: "党员" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "移动电话", prop: "tel" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "8" },
                              attrs: {
                                placeholder: "请输入移动电话",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.tel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "tel", $$v)
                                },
                                expression: "ruleForm.tel",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "出生日期", prop: "date_birth" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "选择出生日期",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.date_birth,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "date_birth", $$v)
                                },
                                expression: "ruleForm.date_birth",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "学生来源", prop: "source_type" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择学生来源",
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.source_type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "source_type", $$v)
                                  },
                                  expression: "ruleForm.source_type",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    value: 1,
                                    label: "成教上清寺高教自考辅导站学生",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { value: 2, label: "成教其他学生" },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    value: 3,
                                    label: "自考交大普通本科二学历学生",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { value: 4, label: "自考其他学生" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "form-title" }, [
                  _vm._v("本人毕业证等信息"),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "专业名称", prop: "pro_degree_id" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择专业名称",
                                  clearable: "",
                                  filterable: "",
                                },
                                on: { change: _vm.professionalDegreeChange },
                                model: {
                                  value: _vm.professionalDegree,
                                  callback: function ($$v) {
                                    _vm.professionalDegree = $$v
                                  },
                                  expression: "professionalDegree",
                                },
                              },
                              _vm._l(
                                _vm.professionalDegreeList,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      value:
                                        item.id +
                                        "," +
                                        item.profession_code +
                                        "," +
                                        item.profession_title +
                                        "," +
                                        item.degree_id +
                                        "," +
                                        item.degree_code +
                                        "," +
                                        item.degree_title,
                                      label: item.profession_title,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "学制", prop: "edu_system" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择学制",
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.edu_system,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "edu_system", $$v)
                                  },
                                  expression: "ruleForm.edu_system",
                                },
                              },
                              _vm._l(_vm.eduSystemList, function (item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { value: item, label: item },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "学习形式", prop: "study_code" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择学习形式",
                                  clearable: "",
                                  filterable: "",
                                },
                                on: { change: _vm.learningFormChange },
                                model: {
                                  value: _vm.learningForm,
                                  callback: function ($$v) {
                                    _vm.learningForm = $$v
                                  },
                                  expression: "learningForm",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: "07-自考", label: "自考" },
                                }),
                                _c("el-option", {
                                  attrs: { value: "04-函授", label: "函授" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.ruleForm.study_code == "07"
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "毕业证书编号",
                                  prop: "exam_number",
                                  rules: [
                                    {
                                      required: true,
                                      message: "请输入毕业证书编号",
                                      trigger: "blur",
                                    },
                                  ],
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { flex: "8" },
                                  attrs: {
                                    placeholder: "请输入毕业证书编号",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.exam_number,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "exam_number", $$v)
                                    },
                                    expression: "ruleForm.exam_number",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ruleForm.study_code == "04"
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "入学年月",
                                  prop: "admission_date",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择入学年月",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.admission_date,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "admission_date",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.admission_date",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "毕业年月", prop: "gra_date" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "请选择毕业年月",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.gra_date,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "gra_date", $$v)
                                },
                                expression: "ruleForm.gra_date",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.ruleForm.study_code == "04"
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "学号", prop: "student_code" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { flex: "8" },
                                  attrs: {
                                    placeholder: "请输入学号(12位)",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.student_code,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "student_code",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.student_code",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ruleForm.study_code == "04"
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "考生号", prop: "exam_number" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { flex: "8" },
                                  attrs: {
                                    placeholder: "请输入考生号(16位)",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.exam_number,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "exam_number", $$v)
                                    },
                                    expression: "ruleForm.exam_number",
                                  },
                                }),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#666",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "说明：在交大学生学习平台查询自己的16位考生号，参考例图"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ruleForm.study_code == "04"
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "例图" } },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px",
                                  },
                                  attrs: {
                                    src: require("../../../assets/images/onlineDeclaration-exam-number1.jpg"),
                                    fit: "contain",
                                    "preview-src-list": [
                                      require("../../../assets/images/onlineDeclaration-exam-number1.jpg"),
                                    ],
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "毕业证盖章页照",
                              prop: "grad_img",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    class: [
                                      "upload",
                                      { no: !_vm.isShowAddGradImg },
                                    ],
                                    attrs: {
                                      action: "",
                                      "list-type": "picture-card",
                                      "file-list": _vm.gradImgFileList,
                                      accept: _vm.accept,
                                      "http-request": (file) =>
                                        _vm.upLoadChange(file, "grad_img"),
                                      "show-file-list": true,
                                      "on-remove": (file, fileList) =>
                                        _vm.handleRemove(
                                          file,
                                          fileList,
                                          "grad_img"
                                        ),
                                      "on-preview": _vm.handlePreview,
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-plus" })]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "form-title" }, [
                  _vm._v("各类成绩信息"),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "学位英语/计算机成绩",
                              prop: "isEnglishOrComputer",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择学位英语/计算机成绩",
                                  clearable: "",
                                  filterable: "",
                                },
                                on: { change: _vm.isEnglishOrComputerChange },
                                model: {
                                  value: _vm.ruleForm.isEnglishOrComputer,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "isEnglishOrComputer",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.isEnglishOrComputer",
                                },
                              },
                              _vm._l(
                                _vm.englishOrComputerList,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      value: item.value,
                                      label: item.label,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.ruleForm.isEnglishOrComputer == "english"
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 60 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "学位英语考试时间",
                                  prop: "english_at",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择学位英语考试时间",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.english_at,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "english_at", $$v)
                                    },
                                    expression: "ruleForm.english_at",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "学位英语考试合格证照片",
                                  prop: "english_img",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { width: "100%" } },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        class: [
                                          "upload",
                                          { no: !_vm.isShowAddEnglish },
                                        ],
                                        attrs: {
                                          action: "",
                                          "list-type": "picture-card",
                                          "file-list": _vm.englishFileList,
                                          accept: _vm.accept,
                                          "http-request": (file) =>
                                            _vm.upLoadChange(
                                              file,
                                              "english_img"
                                            ),
                                          "show-file-list": true,
                                          "on-remove": (file, fileList) =>
                                            _vm.handleRemove(
                                              file,
                                              fileList,
                                              "english_img"
                                            ),
                                          "on-preview": _vm.handlePreview,
                                        },
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.ruleForm.isEnglishOrComputer == "computer"
                  ? _c(
                      "el-row",
                      { attrs: { gutter: 60 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "计算机等级考试时间",
                                  prop: "computer_at",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择计算机等级考试时间",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.computer_at,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "computer_at", $$v)
                                    },
                                    expression: "ruleForm.computer_at",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "计算机等级考试合格证照片",
                                  prop: "computer_img",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { width: "100%" } },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        class: [
                                          "upload",
                                          { no: !_vm.isShowAddComputer },
                                        ],
                                        attrs: {
                                          action: "",
                                          "list-type": "picture-card",
                                          "file-list": _vm.computerFileList,
                                          accept: _vm.accept,
                                          "http-request": (file) =>
                                            _vm.upLoadChange(
                                              file,
                                              "computer_img"
                                            ),
                                          "show-file-list": true,
                                          "on-remove": (file, fileList) =>
                                            _vm.handleRemove(
                                              file,
                                              fileList,
                                              "computer_img"
                                            ),
                                          "on-preview": _vm.handlePreview,
                                        },
                                      },
                                      [_c("i", { staticClass: "el-icon-plus" })]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "平均成绩", prop: "average_score" },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "8" },
                              attrs: {
                                placeholder: "请输入平均成绩",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.average_score,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "average_score", $$v)
                                },
                                expression: "ruleForm.average_score",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "论文成绩", prop: "paper_score" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "8" },
                              attrs: {
                                placeholder: "请输入论文成绩",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.paper_score,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "paper_score", $$v)
                                },
                                expression: "ruleForm.paper_score",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "成绩总表", prop: "score_img" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    class: [
                                      "upload",
                                      { no: !_vm.isShowAddScore },
                                    ],
                                    attrs: {
                                      action: "",
                                      "list-type": "picture-card",
                                      "file-list": _vm.scoreImgFileList,
                                      accept: _vm.accept,
                                      "http-request": (file) =>
                                        _vm.upLoadChange(file, "score_img"),
                                      "show-file-list": true,
                                      "on-remove": (file, fileList) =>
                                        _vm.handleRemove(
                                          file,
                                          fileList,
                                          "score_img"
                                        ),
                                      "on-preview": _vm.handlePreview,
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-plus" })]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "form-title" }, [
                  _vm._v("毕业论文(设计)信息提交"),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: { label: "导师姓名", prop: "mentor_title" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入导师姓名",
                                clearable: "",
                                maxlength: "60",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.mentor_title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "mentor_title", $$v)
                                },
                                expression: "ruleForm.mentor_title",
                              },
                            }),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v(
                                "备注：允许多个导师，兼容中英文，用中文或英文分号分隔，120字符内"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: { label: "论文类型", prop: "paper_type" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择论文类型",
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.paper_type,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "paper_type", $$v)
                                  },
                                  expression: "ruleForm.paper_type",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    value: "毕业论文",
                                    label: "毕业论文",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    value: "毕业设计",
                                    label: "毕业设计",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v("备注：参考资料库标准表"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: { label: "论文题目", prop: "paper_title" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入论文题目",
                                clearable: "",
                                maxlength: "120",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.paper_title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "paper_title", $$v)
                                },
                                expression: "ruleForm.paper_title",
                              },
                            }),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v("备注：240字符内"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: { label: "论文关键词", prop: "paper_key" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入论文关键词",
                                clearable: "",
                                maxlength: "60",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.paper_key,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "paper_key", $$v)
                                },
                                expression: "ruleForm.paper_key",
                              },
                            }),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v(
                                "备注：3-5个关键词，每个关键词之间用中文或英文分号分隔开，120字符内"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: {
                              label: "论文选题来源",
                              prop: "paper_topic",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入论文选题来源",
                                clearable: "",
                                maxlength: "15",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.paper_topic,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "paper_topic", $$v)
                                },
                                expression: "ruleForm.paper_topic",
                              },
                            }),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v("备注：统一填“其他”"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: {
                              label: "论文研究方向",
                              prop: "paper_research",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "请输入论文研究方向",
                                clearable: "",
                                maxlength: "40",
                                "show-word-limit": "",
                              },
                              model: {
                                value: _vm.ruleForm.paper_research,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "paper_research", $$v)
                                },
                                expression: "ruleForm.paper_research",
                              },
                            }),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v(
                                "备注：最多可填2个方向，用中文或英文分号分隔，80个字符内"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "item-box line",
                            attrs: {
                              label: "论文撰写语种",
                              prop: "paper_lang",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "请选择论文撰写语种",
                                  clearable: "",
                                  filterable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.paper_lang,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "paper_lang", $$v)
                                  },
                                  expression: "ruleForm.paper_lang",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: "中文", label: "中文" },
                                }),
                                _c("el-option", {
                                  attrs: { value: "英文", label: "英文" },
                                }),
                              ],
                              1
                            ),
                            _c("span", { staticClass: "item-tips" }, [
                              _vm._v("备注：参考资料库标准表"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "form-title" }, [
                  _vm._v("学位证书用电子照片"),
                ]),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { prop: "degree_img" } }, [
                          _c(
                            "div",
                            { staticStyle: { width: "100%" } },
                            [
                              _c(
                                "el-upload",
                                {
                                  class: [
                                    "upload",
                                    { no: !_vm.isShowAddDegree },
                                  ],
                                  attrs: {
                                    action: "",
                                    "list-type": "picture-card",
                                    "file-list": _vm.degreeFileList,
                                    accept: _vm.accept,
                                    "http-request": (file) =>
                                      _vm.upLoadChange(file, "degree_img"),
                                    "show-file-list": true,
                                    "on-remove": (file, fileList) =>
                                      _vm.handleRemove(
                                        file,
                                        fileList,
                                        "degree_img"
                                      ),
                                    "on-preview": _vm.handlePreview,
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-plus" })]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticClass: "color-red" }, [
                        _c("p", [_vm._v("注意：")]),
                        _c("p", [
                          _vm._v(
                            " 1、纸质小2寸照片，必须与本科毕业证照片一致。（ "
                          ),
                          _c("span", [_vm._v("毕业证照片可在")]),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://www.chsi.com.cn/",
                                target: "_blank",
                              },
                            },
                            [
                              _c("span", { staticClass: "color-blue" }, [
                                _vm._v("学信网"),
                              ]),
                            ]
                          ),
                          _c("span", [_vm._v("上截取")]),
                          _vm._v(" ） "),
                        ]),
                        _c("p", [
                          _vm._v(
                            "2、电子照片（必须命名为 张 三 513132199210121028.jpg）， "
                          ),
                          _c("span", [
                            _vm._v(
                              "电子照片大小为10一40KB且像素尺寸为（宽）480*（高）640，图片必须用jpg格式"
                            ),
                          ]),
                          _vm._v("。电子照片在网上申报时提交。"),
                        ]),
                        _c("p", [
                          _vm._v(
                            "3、申请学位所需电子照片格式不符合要求者，将无法完成学位信息网上报送工作！"
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "form-title" }, [_vm._v("其他信息")]),
                _c(
                  "el-row",
                  { attrs: { gutter: 60 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注", prop: "remark" } },
                          [
                            _c("el-input", {
                              staticStyle: { flex: "8" },
                              attrs: {
                                type: "textarea",
                                rows: "4",
                                placeholder: "请输入备注",
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "remark", $$v)
                                },
                                expression: "ruleForm.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "btn" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: { click: _vm.submit },
              },
              [_vm._v("提交")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: { width: "40%", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticStyle: { "max-width": "100%" },
              attrs: { src: _vm.dialogImageUrl, alt: "图片" },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top" }, [
      _c("img", {
        staticClass: "onlineDeclaration-img",
        attrs: {
          src: require("../../../assets/images/degreeApplication/onlineDeclaration.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }